import React from 'react';
import Grid from '@mui/material/Grid2';
import MediaCard from '../GoogleMapsTestPage/MediaCard';

const MediaGrid = ({
    mediaPoints,
    onCardClick,
    selectedMediaId,
    gridItemProps,
    favoriteIds,
    onToggleFavorite,
    onToggleLike,
    onShareClick,
    onDeleteClick,
    onReportClick,
    onBlockClick,
    onBlockUserClick
}) => {
    const defaultGridItemProps = { xs: 12, sm: 6, md: 4, lg: 3 };

    if (!mediaPoints || mediaPoints.length === 0) {
        return null;
    }

    return (
        <Grid container spacing={2}>
            {mediaPoints.map(mediaPoint => (
                <Grid key={`media-${mediaPoint.id}`} size={gridItemProps || defaultGridItemProps}>
                    <MediaCard
                        mediaPoint={mediaPoint}
                        onClick={() => onCardClick(mediaPoint)}
                        isSelected={selectedMediaId === mediaPoint.id}
                        isFavorite={favoriteIds.has(mediaPoint.id)}
                        onToggleFavorite={onToggleFavorite}
                        onToggleLike={onToggleLike}
                        onShareClick={onShareClick}
                        onDeleteClick={onDeleteClick}
                        onReportClick={onReportClick}
                        onBlockClick={onBlockClick}
                        onBlockUserClick={onBlockUserClick}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default MediaGrid;